export default {
  paged: {
    select: 'id,isActive,status,canCreateCustomers',
    searchSelect: ['company/commercialName', 'ownerCompany/commercialName', 'agreement/name'],
    orderBy: 'company/commercialName asc',
    expand: {
      company: {
        select: 'commercialName',
      },
      ownerCompany: {
        select: 'commercialName',
      },
      agreement: {
        select: 'name',
      },
    },
  },
  itemDetail: {
    expand: {
      company: {
        select: 'commercialName',
      },
      ownerCompany: {
        select: 'commercialName',
      },
      agreement: {
        select: 'name',
      },
    },
  },
};
